import { defineStore } from "pinia";
import { ref } from "vue";

import axios from "axios";

interface AgencyContact {
    label: string,
    value: string
}

export const useAgencyContactsStore = defineStore("agencyContacts", () => {
    const loading = ref(false);

    const items = ref<AgencyContact[]>();

    const list = async (ori: string) => {

        try {
            loading.value = true;
            const response = await axios.get<AgencyContact[]>(`api/v1/audit/audits/agency-contacts`, {
                params: {
                    ori: ori
                }
            });
            items.value = response.data;
        }
        finally {
            loading.value = false;
        }
    }

    return { loading, list, items };
});